/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type { Client, RequestConfig, ResponseErrorConfig } from "#client";
import type {
	OrgUnitReserveRetrievePathOrgUnitId,
	OrgUnitReserveRetrievePathReserveId,
	OrgUnitReserveRetrieveQueryRefresh,
	OrgUnitReserveRetrieveStatus200,
} from "../types/OrgUnitReserveRetrieve.ts";
import type { QueryKey, QueryClient, UseQueryOptions, UseQueryReturnType } from "@tanstack/vue-query";
import type { MaybeRefOrGetter } from "vue";
import { orgUnitReserveRetrieve } from "../requests/orgUnitReserveRetrieve.ts";
import { queryOptions, useQuery } from "@tanstack/vue-query";
import { toValue } from "vue";

export const orgUnitReserveRetrieveQueryKey = (
	org_unit_id?: MaybeRefOrGetter<OrgUnitReserveRetrievePathOrgUnitId>,
	reserve_id?: MaybeRefOrGetter<OrgUnitReserveRetrievePathReserveId>,
	params?: MaybeRefOrGetter<{ refresh?: OrgUnitReserveRetrieveQueryRefresh }>,
) =>
	[
		{ url: "/api/org_unit/:org_unit_id/reserve/:reserve_id/", params: { org_unit_id: org_unit_id, reserve_id: reserve_id } },
		...(params ? [params] : []),
	] as const;

export type OrgUnitReserveRetrieveQueryKey = ReturnType<typeof orgUnitReserveRetrieveQueryKey>;

export function orgUnitReserveRetrieveQueryOptions(
	org_unit_id?: MaybeRefOrGetter<OrgUnitReserveRetrievePathOrgUnitId>,
	reserve_id?: MaybeRefOrGetter<OrgUnitReserveRetrievePathReserveId>,
	params?: MaybeRefOrGetter<{ refresh?: OrgUnitReserveRetrieveQueryRefresh }>,
	config: Partial<RequestConfig> & { client?: Client } = {},
) {
	const queryKey = orgUnitReserveRetrieveQueryKey(org_unit_id, reserve_id, params);
	return queryOptions<OrgUnitReserveRetrieveStatus200, ResponseErrorConfig<Error>, OrgUnitReserveRetrieveStatus200>({
		enabled: () => !!toValue(org_unit_id) && !!toValue(reserve_id),
		queryKey,
		queryFn: async ({ signal }) => {
			return orgUnitReserveRetrieve(toValue(org_unit_id!), toValue(reserve_id!), toValue(params), { ...config, signal: config.signal ?? signal });
		},
	});
}

/**
 * @summary статус брони
 * {@link /api/org_unit/:org_unit_id/reserve/:reserve_id/}
 */
export function useOrgUnitReserveRetrieve<
	TData = OrgUnitReserveRetrieveStatus200,
	TQueryData = OrgUnitReserveRetrieveStatus200,
	TQueryKey extends QueryKey = OrgUnitReserveRetrieveQueryKey,
>(
	org_unit_id?: MaybeRefOrGetter<OrgUnitReserveRetrievePathOrgUnitId>,
	reserve_id?: MaybeRefOrGetter<OrgUnitReserveRetrievePathReserveId>,
	params?: MaybeRefOrGetter<{ refresh?: OrgUnitReserveRetrieveQueryRefresh }>,
	options: {
		query?: Partial<UseQueryOptions<OrgUnitReserveRetrieveStatus200, ResponseErrorConfig<Error>, TData, TQueryData, TQueryKey>> & { client?: QueryClient };
		client?: Partial<RequestConfig> & { client?: Client };
	} = {},
) {
	const { query: queryConfig = {}, client: config = {} } = options ?? {};
	const { client: queryClient, ...resolvedOptions } = queryConfig;
	const queryKey =
		(resolvedOptions && "queryKey" in resolvedOptions ? toValue(resolvedOptions.queryKey) : undefined) ??
		orgUnitReserveRetrieveQueryKey(org_unit_id, reserve_id, params);

	const query = useQuery(
		{
			...orgUnitReserveRetrieveQueryOptions(org_unit_id, reserve_id, params, config),
			...resolvedOptions,
			queryKey,
		} as unknown as UseQueryOptions<OrgUnitReserveRetrieveStatus200, ResponseErrorConfig<Error>, TData, OrgUnitReserveRetrieveStatus200, TQueryKey>,
		toValue(queryClient),
	) as UseQueryReturnType<TData, ResponseErrorConfig<Error>> & { queryKey: TQueryKey };

	query.queryKey = queryKey as TQueryKey;

	return query;
}
